<template lang="pug">
div.task-point-create-edit
  div.mb2(style="text-align: right;")
    a-button(type="primary" @click="$refs.addBrands.show(target)") 添加品牌
    a-button.ml2(type="danger" 
    @click="handleDeleteBatch" 
    :disabled="!canDeleteBatch"
    ) 批量删除
  AddBrands(ref="addBrands"  @modal-success="$emit('reload')")
  app-custom-table(
    ref="table"
    :tableData="brands"
    :tableColumns="tableColumns"
    @row-click="handleRowClick"
    @loaded="handleRowClick"
    noPagination
  )
  
</template>

<script>
import AddBrands from '../Modal/AddBrands';

import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';

import _ from 'lodash';
export default {
  name: 'PointDTOS',
  components: {
    AddBrands,
  },
  props: {
    brands: Array,
    target: Object,
  },
  data() {
    return {
      itemList: [],
      model: {
        objectType: null,
        objectKey: null,
        standardIds: [], // 标准
      },
      rules: {
        objectType: [{ required: true, message: '必填项' }],
        objectKey: [{ required: true, message: '必填项' }],
      },
      //
      tableColumns: [],
      //
      canDeleteBatch: false,
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  created() {
    // 初始化
    this.initTableColumns();
    this.initFilters();
  },
  methods: {
    handleDelete(r, index) {
      this.$restful(`DELETE:/prj/suppliers/${this.target.id}/brands`, {
        brandIds: [r.id],
      }).then((res) => {
        // console.log(res);
        this.$message.success('操作成功!');
        this.$emit('reload');
        this.$refs.table.selections = [];
      });
    },

    // 批量删除品牌
    handleDeleteBatch() {
      const brands = this.$refs.table.selections || [];
      const ids = brands.map((item) => item.id);
      this.$restful(`DELETE:/prj/suppliers/${this.target.id}/brands`, {
        brandIds: ids,
      }).then((res) => {
        // console.log(res);
        this.$message.success('操作成功!');
        this.$emit('reload');
        this.$refs.table.selections = [];
      });
    },
    //
    handleRowClick() {
      this.canDeleteBatch = !!this.$refs?.table?.selections?.length;
    },
    // 初始化表格 列
    initTableColumns() {
      this.tableColumns = [
        {
          uid: 'name',
          dataIndex: 'name',
          title: '品牌名称',
          width: '200px',
        },
        {
          uid: 'code',
          dataIndex: 'code',
          title: '品牌代码',
          width: '200px',
        },
        {
          uid: 'actions',
          dataIndex: 'actions',
          title: '操作',
          width: '200px',
          render: (h, v, r, index) => {
            return (
              <div>
                <app-link-btn
                  title="编辑"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleDelete(r);
                  }}
                >
                  删除
                </app-link-btn>
              </div>
            );
          },
        },
      ];
    },
    //
    initFilters() {
      this.deviceFilterFieleds = [
        {
          name: 'typeId',
          placeholder: '请选择设备类型',
          width: '150px',
          component: 'app-remote-select',
          api: '/prj/device-types/all-graph',
          params: { projectId: this.project.id },
        },
        {
          name: 'areaId',
          placeholder: '请选择所属区域',
          width: '250px',
          component: 'app-cascader',
          api: '/prj/areas/all-graph',
          params: { projectId: this.project.id },
          mode: 'single',
        },
      ];
      this.spaceFilterFieleds = [
        {
          name: 'attribute',
          placeholder: '请选择档位属性',
          width: '150px',
          component: 'app-remote-select',
          api: '/sys/dict-datas/graph?typeCode=spaceAttr',
          field: { name: 'code', label: 'name' },
        },
        {
          name: 'areaId',
          placeholder: '请选择所属区域',
          width: '250px',
          component: 'app-cascader',
          api: '/prj/areas/all-graph',
          params: { projectId: this.project.id },
          mode: 'single',
        },
      ];
      this.filterFieleds2 = [
        {
          name: 'type',
          placeholder: '请选择标准类型',
          width: '150px',
          component: 'app-dict-select',
          code: 'inspContentType',
          field: { name: 'code', label: 'name' },
          onChange: (val) => {
            // 联动
            if (val === 'inspContentType_deviceInsp') {
              this.filterFieleds2.splice(1, 1, {
                ...this.filterFieleds2[1],
                hide: false,
              });
            } else {
              this.filterFieleds2.splice(1, 1, {
                ...this.filterFieleds2[1],
                hide: true,
              });
            }
          },
        },
        {
          hide: true,
          name: 'deviceTypeId',
          placeholder: '请选择设备类型',
          width: '150px',
          component: 'app-remote-select',
          api: '/prj/device-types/all-graph',
          params: { projectId: this.project.id },
        },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
.task-point-create-edit {
  // margin-left: -90px;
  // margin-top: -4px;
  // width: calc(100% + 90px);
  .insp-item-list {
    // display: ;
    .insp-item-list-head,
    .insp-item-list-body {
      text-align: center;
      .item-name,
      .item-type,
      .item-config,
      .item-action {
        padding: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        word-break: break-all;
      }
      .item-name {
        flex: 1;
      }
      .item-type {
        flex: 1;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
      .item-config {
        flex: 3;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .item-action {
        flex: 1;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
    .insp-item-list-head {
      color: rgba(0, 0, 0, 0.85);
      border: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(0, 0, 0, 0.05);
    }
    .insp-item-list-body {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-top-width: 0;
    }
    .item-row {
      justify-content: stretch;
      & + .item-row {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
  .insp-object {
    .insp-object-name {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
